import i18next from 'i18next';
import { SelectChangeEvent } from '@mui/material';
import { useAvailableLanguages } from '../../../../hooks/useAvailableLanguages';
import { useLanguage } from '../../../../localization/LanguageInstanceProvider';
import { LanguageType } from '../../../../@types';
import StyledSelect from './StyledSelect';

const SelectLanguage = () => {
  const availableLanguages = useAvailableLanguages();
  const { setSelectedLanguage } = useLanguage();

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const selectedLang = event.target.value as LanguageType;
    setSelectedLanguage(selectedLang);
  };

  if (!availableLanguages.length) return null;

  return (
    <StyledSelect value={i18next.language || ''} handleChange={handleLanguageChange} itemsList={availableLanguages} />
  );
};

export default SelectLanguage;
